import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { AdminsApi } from 'api';
import { UpdateAdminType } from 'types';

function useUpdate() {
  const queryClient = useQueryClient();
  return useAuthMutation(
    ({ id, ...rest }: UpdateAdminType & { id: number }) =>
      AdminsApi.put(id, rest),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useUpdate;
